import React from "react";
import BusinessAdministrationHeader from "../components/Courses/BusinessAdministration/BusinessAdministrationHeader";
import BusinessAdministrationCareerSkills from "../components/Courses/BusinessAdministration/BusinessAdministrationCareerSkills";
import BusinessAdministrationProgramsCard from "../components/Courses/BusinessAdministration/ExploreProgramsBusinessAdministration";
import BusinessAdministrationAdmissionRequirements from "../components/Courses/BusinessAdministration/BusinessAdministrationAdmissionRequirements";
import FullScreenImage from "../components/Home/ShowcaseSection";
import Footer from "../components/sub-comp/MainFooter";
import Navbar from "../components/sub-comp/Navbar";

const BusinessAdministration = () => {
  return (
    <div>
      <Navbar />
      <BusinessAdministrationHeader />
      <BusinessAdministrationCareerSkills />
      <BusinessAdministrationProgramsCard />
      <BusinessAdministrationAdmissionRequirements />
      <FullScreenImage />
      <Footer />
    </div>
  );
};

export default BusinessAdministration;
